import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EMarketingClientPath } from '~/models/api'

export const marketingRoutesFileToRouteMap: TFileToRouteMap = {
  loadingItem: {
    path: EMarketingClientPath.loadingItem,
    getImportPromise: () => import('~/pages/loadingItem'),
  },
  payments: {
    path: EMarketingClientPath.payments,
    getImportPromise: () => import('~/pages/payments'),
  },
}

const marketingRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  marketingRoutesFileToRouteMap,
)

export default marketingRoutes
